import { inject, Injectable } from '@angular/core';
import { UserAccount } from '../models/user-account.model';
import { map, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { convertKeysToCamelCase } from '../../shared/utilities/json-key-transform';
import { SearchAccountsRequest } from '../models/search-accounts.request';
import { SearchUsersResponse } from '../models/search-users.response';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private http = inject(HttpClient);
  private apiUrl = environment.tenantManagementApi.serviceBaseUrl;

  searchAccounts(request: SearchAccountsRequest): Observable<UserAccount[]>  {
    return this.http.post<SearchUsersResponse>(this.apiUrl+"/SearchAllUserAccounts", request).pipe(
      map(response => {
        let camelCase = convertKeysToCamelCase(response) as SearchUsersResponse;
        return camelCase.userAccounts;
      })
    );
  }
}
